<template>
  <div class="turntable" ref="turntable">
    <canvas ref="canvas" class="canvas"></canvas>
    <ul class="turntable-list">
      <li class="discount-item" v-for="(item, index) in $bus.discountPool"
        :key="index"
        :class="[item.status === 2 ? 'dark' : '', item.discountType === 0 ? 'diamond-type': 'discount-type']">
        <i class="diamond-discount" v-if="item.discountType === 0"></i>
        <span class="discount-text krona-font" :class="getClass(item.status)" v-else>{{item.discount + '%'}}</span>
        <span class="discount-text" :class="getTextClass(item)">{{item.discountType === 0 ? item.discount : $bus.transify['LUCKY_OFF']}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { debounce, addGA } from '@/utils/assist'

export default {
  data () {
    return {
      context: null,
      dialogTimer: null,
      closeDrawSoundTimer: null
    }
  },
  watch: {
    '$bus.discountPool': {
      handler (val) {
        if (val.length > 0) {
          this.drawPrize() // 绘制奖品
        }
      },
      deep: true
    },
    '$bus.deltaAngle': {
      handler (current) {
        const turntable = this.$refs.turntable
        if (this.$bus.animating) {
          turntable.style.transition = 'transform 3s cubic-bezier(0,.47,.31,1.03)'
          turntable.style.transform = `rotate(${current}deg)`
          clearTimeout(this.closeDrawSoundTimer)
          this.closeDrawSoundTimer = setTimeout(() => {
            clearTimeout(this.closeDrawSoundTimer)
            this.$bus.drawSound = false
          }, 2900)
          // 显示discount动画
          clearTimeout(this.dialogTimer)
          this.dialogTimer = setTimeout(() => {
            clearTimeout(this.dialogTimer)

            this.$bus.discountInfo.show = true
            this.$bus.animating = false
            // 处理选中的状态
            if (this.$bus.enable !== -1) {
              const index = this.$bus.discountPool.findIndex(item => item.pk === this.$bus.enable)
              this.$bus.discountPool[index].status = 1
            }
          }, 3500)
        } else {
          turntable.style.transition = 'none'
          turntable.style.transform = `rotate(${current}deg)`
          // 处理选中的状态
          if (this.$bus.enable !== -1) {
            const index = this.$bus.discountPool.findIndex(item => item.pk === this.$bus.enable)
            this.$bus.discountPool[index].status = 1
          }
        }
      }
    }
  },
  methods: {
    getClass (status) {
      return status === 2 ? 'discount-text__dark' : ''
    },
    getTextClass (item) {
      return [
        item.discountType === 0 && item.status !== 2 ? 'light' : 'off',
        this.getClass(item.status),
        item.status === 2 && item.discountType === 0 ? 'off-grand' : ''
      ]
    },
    initCanvas () { // 初始化canvas
      const canvas = this.$refs.canvas
      canvas.width = this.$refs.turntable.offsetWidth
      canvas.height = this.$refs.turntable.offsetHeight
      if (canvas.getContext) {
        this.context = canvas.getContext('2d')
        this.context.imageSmoothingEnabled = true
        this.context.beginPath()
        this.context.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, false)
        this.drawFrame()
        // this.drawPrize()
      }
    },
    drawFrame () {
      const canvas = this.$refs.canvas
      const grad = this.context.createLinearGradient(0, 0, canvas.width, canvas.height)
      grad.addColorStop(0, '#ff850d')
      grad.addColorStop(1, '#9f0e90')

      this.context.beginPath()
      this.context.moveTo(canvas.width / 2, canvas.height / 2)
      this.context.arc(canvas.width / 2, canvas.height / 2, (canvas.width - 3) / 2, 0, Math.PI * 2, false)
      this.context.fillStyle = grad
      this.context.fill()
      this.drawPrize()
    },
    drawPrize () { // 绘制奖品区域
      const canvas = this.$refs.canvas
      const discountPool = this.$bus.discountPool
      const len = discountPool.length || 8 // 默认8个

      // 绘制转盘
      let [ context, startRadian, RadianGap ] = [ this.context, 3.55, Math.PI * 2 / len ]
      let endRadian = startRadian + RadianGap
      let grad = context.createLinearGradient(canvas.width * (40 / 392), canvas.height * (192 / 392), canvas.width * (10 / 392), canvas.height * (30 / 392))
      grad.addColorStop(0, '#ff9000')
      grad.addColorStop(1, '#ffea5e')
      for (let i = 0; i < len; i++) {
        let status = discountPool.length > 0 ? discountPool[i].status : 0
        context.save()
        context.beginPath()
        // 大奖
        if (i === 0) {
          context.fillStyle = grad
          if (status === 1) {
            context.fillStyle = '#ec1f2b'
          }
          if (status === 2) {
            context.fillStyle = '#7f7f7f'
          }
        } else if (i % 2 === 0) {
          context.fillStyle = 'rgba(171, 41, 71, .8)'
          if (status === 1) {
            context.fillStyle = '#ec1f2b'
          }
          if (status === 2) {
            context.fillStyle = '#6b6b6b'
          }
        } else {
          if (status === 1) {
            context.fillStyle = '#ec1f2b'
          }
          if (status === 2) {
            context.fillStyle = '#7f7f7f'
          }
        }
        context.moveTo(canvas.width / 2, canvas.height / 2)
        context.arc(canvas.width / 2, canvas.height / 2, (canvas.width - 7) / 2, startRadian, endRadian, false)
        context.fill()
        context.restore()
        startRadian += RadianGap
        endRadian += RadianGap
      }
      this.drawCiycle(canvas.width / 7)
      this.drawCiycle(canvas.width / 9)
    },
    drawCiycle (radius) { // 绘制圆圈
      const canvas = this.$refs.canvas
      let context = this.context
      context.beginPath()
      context.arc(canvas.width / 2, canvas.height / 2, radius, 0, Math.PI * 2, false)
      context.strokeStyle = 'rgba(255, 50, 50, 1)'
      context.stroke()
    }
  },
  mounted () {
    this.initCanvas()
    window.addEventListener('resize', debounce(this.initCanvas, 200))
  }
}
</script>

<style lang="scss" scoped>
.turntable {
  width: 100%;
  height: 100%;
}
.canvas {
  display: block;
  margin: 0 auto;
}
.turntable-list {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.discount-item {
  position: absolute;
  @include flexcc;
  @include px2res(width, 120);
}
.discount-item:nth-child(1) {
  transform: rotate(-45deg);
  @include px2res(left, 40);
  @include px2res(top, 46);
}
.discount-item:nth-child(2) {
  &.discount-type {
    @include px2res(left, 136);
    @include px2res(top, 18);
  }
  &.diamond-type {
    @include px2res(left, 134);
    @include px2res(top, 8);
  }
  &::after {
    content: '';
    transform: rotate(92deg);
    @include px2res(left, -36);
    @include px2res(top, -4)
  }
}
.discount-item:nth-child(3) {
  transform: rotate(45deg);
  &.discount-type {
    @include px2res(left, 238);
    @include px2res(top, 62);
  }
  &.diamond-type {
    @include px2res(left, 231);
    @include px2res(top, 47);
  }
}
.discount-item:nth-child(4) {
  transform: rotate(90deg);
  &.discount-type {
    @include px2res(left, 282);
    @include px2res(top, 164);
  }
  &.diamond-type {
    @include px2res(left, 272);
    @include px2res(top, 142);
  }
  &::after {
    content: '';
    transform: rotate(91deg);
    @include px2res(left, -36);
    @include px2res(top, -4)
  }
}
.discount-item:nth-child(5) {
  transform: rotate(135deg);
  &.discount-type {
    @include px2res(left, 240);
    @include px2res(top, 270);
  }
  &.diamond-type {
    @include px2res(left, 234);
    @include px2res(top, 240);
  }
}
.discount-item:nth-child(6) {
  transform: rotate(180deg);
  &.discount-type {
    @include px2res(left, 136);
    @include px2res(bottom, 12);
  }
  &.diamond-type {
    @include px2res(left, 136);
    @include px2res(bottom, 8);
  }
  &::after {
    content: '';
    transform: rotate(91deg);
    @include px2res(left, -36);
    @include px2res(top, 4)
  }
}
.discount-item:nth-child(7) {
  transform: rotate(-135deg);
  &.discount-type {
    @include px2res(left, 30);
    @include px2res(bottom, 62);
  }
  &.diamond-type {
    @include px2res(left, 42);
    @include px2res(bottom, 47);
  }
}
.discount-item:nth-child(8) {
  transform: rotate(-90deg);
  &.discount-type {
    @include px2res(left, -14);
    @include px2res(top, 162);
  }
  &.diamond-type {
    @include px2res(left, -2);
    @include px2res(top, 144);
  }
  &::after {
    content: '';
    transform: rotate(91deg);
    @include px2res(left, -38);
    @include px2res(top, 0)
  }
}
.diamond-discount {
  @include px2res(width, 71);
  @include px2res(height, 63);
}
.discount-text {
  @include px2res(font-size, 28);
  text-transform: uppercase;

  &.discount-text__dark {
    color: #343434;
  }
}
.discount-text.light {
  @include px2res(font-size, 30);
  color: #00c0ff;
  background: linear-gradient(115deg,#00fffc 0%, #00c0ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}
.discount-text.off {
  @include px2res(font-size, 22);
}
.discount-text.off-grand {
  @include px2res(font-size, 30);
}
.discount-item.dark {
  .diamond-discount {
    filter: grayscale(1);
  }
  .discount-text.light {
    color: #8c8c8c;
    background: linear-gradient(135deg,#fff 0%, #8c8c8c 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  &::after {
    filter: grayscale(1);
  }
}
.discount-item::after {
  position: absolute;
  @include px2res(width, 194);
  @include px2res(height, 146);
}
</style>



// WEBPACK FOOTER //
// src/components/main/turntable.vue